module.exports = __webpack_public_path__ + "img/schulungen-poster.b078f751.png";